import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    margin: 0 auto 16px;
    max-width: 1440px;
    width: calc(100% - 48px);

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
      width: 100%;
    }
  `}
`;
